import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  marginTop: {
    marginTop: 5,
  },
  flexContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    margin: 10,
  },
  btnPrimary: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: '#000A8C',
    color: '#fff',
    '@media(min-width: 600px)': {},
  },
  textHeader: {
    display: 'none',
    marginLeft: 0,
    '@media(min-width: 600px)': {
      display: 'block',
    },
  },
  sectionTitle: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
    color: '#FFFFFF',
    backgroundColor: '#000A8C',
    padding: '16px 24px',
    borderRadius: '8px',
    margin: 0,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));
